import { Config } from '../../config'

export const herrConfig: Config = {
  partner: 'herr',
  catalog: 'partner',
  displayName: 'Herr Enterprises',
  accentColor: '#d14343',
  host: 'seating.herrenterprises.com'
}

